// extracted by mini-css-extract-plugin
export var dropOver = "_ms-2";
export var dropValid = "_ms-1";
export var hidden = "_ms-3";
export var line = "_ms-0";